var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgList({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "System/Line/List"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Union"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 8C5.55228 8 6 7.55228 6 7C6 6.44772 5.55228 6 5 6C4.44772 6 4 6.44772 4 7C4 7.55228 4.44772 8 5 8Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 13C5.55228 13 6 12.5523 6 12C6 11.4477 5.55228 11 5 11C4.44772 11 4 11.4477 4 12C4 12.5523 4.44772 13 5 13Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 17C6 17.5523 5.55228 18 5 18C4.44772 18 4 17.5523 4 17C4 16.4477 4.44772 16 5 16C5.55228 16 6 16.4477 6 17Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 6C8.44772 6 8 6.44772 8 7C8 7.55228 8.44772 8 9 8L19 8C19.5523 8 20 7.55229 20 7C20 6.44772 19.5523 6 19 6L9 6Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 12C8 11.4477 8.44772 11 9 11L19 11C19.5523 11 20 11.4477 20 12C20 12.5523 19.5523 13 19 13L9 13C8.44772 13 8 12.5523 8 12Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 16C8.44772 16 8 16.4477 8 17C8 17.5523 8.44772 18 9 18L19 18C19.5523 18 20 17.5523 20 17C20 16.4477 19.5523 16 19 16L9 16Z",
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/List.271758051f0221052a534420bd4f8092.svg";
export { ForwardRef as ReactComponent };